module.exports = __webpack_public_path__ + "img/leaf-life.e3a2deba.svg";